exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer{width:100%;height:60px;padding:20px 0;background-color:#f5f5f5;position:absolute;bottom:0}", "", {"version":3,"sources":["/./src/app/components/footer/src/app/components/footer/footer.scss"],"names":[],"mappings":"AAAA,OACE,WAAW,AACX,YAAY,AACZ,eAAe,AACf,yBAAyB,AACzB,kBAAkB,AAClB,QAAS,CACV","file":"footer.scss","sourcesContent":["footer {\n  width: 100%;\n  height: 60px;\n  padding: 20px 0;\n  background-color: #f5f5f5;\n  position: absolute;\n  bottom: 0;\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/footer/footer.scss
// module id = 900
// module chunks = 0